import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { defineAsyncComponent } from 'vue';

import useBreakpoints from '@exchange/libs/composables/shared/src/lib/useBreakpoints';
import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilledOrders',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  dragging: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
},
  setup(__props) {

const FilledOrdersListDesktop = defineAsyncComponent(() => import(/* webpackChunkName: "chunk-filled-order-list-desktop" */ './desktop/FilledOrdersListDesktop.vue'));
const FilledOrdersListMobile = defineAsyncComponent(() => import(/* webpackChunkName: "chunk-filled-order-list-mobile" */ './mobile/FilledOrdersListMobile.vue'));



const breakpoints = {
  590: 'hide-type compact-side hide-currency', // 'compact-side hide-time hide-currency',
  750: 'hide-type compact-side', // 'compact-side compact-order-type hide-time',
  785: 'hide-type compact-side', // 'compact-side compact-order-type',
  800: 'hide-type compact-side', // 'compact-side',
  bigger: 'hide-type',
};

const { isXS } = useMQBreakpoints();
const { currentBreakPoint, watchedEl: wrapperRef } = useBreakpoints(breakpoints);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "wrapperRef",
    ref: wrapperRef,
    class: "filled-orders"
  }, [
    (!_unref(isXS))
      ? (_openBlock(), _createBlock(_unref(FilledOrdersListDesktop), {
          key: 0,
          class: "filled-orders__list",
          "list-item-class": "filled-orders-list__item",
          "show-order-type": false,
          "authenticated-user": __props.authenticatedUser,
          breakpoint: _unref(currentBreakPoint),
          dragging: __props.dragging,
          "market-id": __props.marketId,
          "show-all-markets": __props.showAllMarkets
        }, null, 8, ["authenticated-user", "breakpoint", "dragging", "market-id", "show-all-markets"]))
      : (_openBlock(), _createBlock(_unref(FilledOrdersListMobile), {
          key: 1,
          class: "filled-orders__list",
          "list-item-class": "filled-orders-list__item",
          "show-order-type": false,
          "authenticated-user": __props.authenticatedUser,
          "market-id": __props.marketId,
          "show-all-markets": __props.showAllMarkets
        }, null, 8, ["authenticated-user", "market-id", "show-all-markets"]))
  ], 512))
}
}

})